import { render, staticRenderFns } from "./AccountMarket.vue?vue&type=template&id=7bb94bd5&scoped=true&"
import script from "./AccountMarket.vue?vue&type=script&lang=ts&"
export * from "./AccountMarket.vue?vue&type=script&lang=ts&"
import style0 from "./AccountMarket.vue?vue&type=style&index=0&id=7bb94bd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb94bd5",
  null
  
)

export default component.exports